import { Navigate } from "react-router-dom";
// routes
import { paths } from "../routes/paths";
// components
import LoadingScreen from "../components/loading-screen";
//
import { useAuthContext } from "./useAuthContext";

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isLoggedIn, isInitialized } = useAuthContext();

  if (isLoggedIn) {
    return <Navigate to={paths.main.root} />;
  }

  if (!isInitialized) {
    return <LoadingScreen showImage />;
  }

  return <> {children} </>;
}
